import { Bounds } from "@/shared/types/data";
import { RefObject, useLayoutEffect, useState } from "react";

export const usePhaserBounds = (
  rootRef: RefObject<HTMLDivElement | null>,
  phaserMountRef: RefObject<HTMLDivElement | null>,
) => {
  const [bounds, setBounds] = useState<Bounds>({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    if (!rootRef || !phaserMountRef) return;

    const update = () => {
      const root = rootRef.current;
      const mount = phaserMountRef.current;
      if (!root || !mount) return;

      const canvas = mount.querySelector("canvas");
      if (!canvas) return;

      const rootRect = root.getBoundingClientRect();
      const canvasRect = canvas.getBoundingClientRect();

      setBounds({
        left: canvasRect.left - rootRect.left,
        top: canvasRect.top - rootRect.top,
        width: canvasRect.width,
        height: canvasRect.height,
      });
    };

    update();

    const resizeObserver = new ResizeObserver(update);

    if (rootRef.current) resizeObserver.observe(rootRef.current);
    if (phaserMountRef.current) resizeObserver.observe(phaserMountRef.current);

    window.addEventListener("resize", update);

    const interval = window.setInterval(update, 250);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", update);
      window.clearInterval(interval);
    };
  }, [rootRef, phaserMountRef]);

  return bounds;
};
